import React from "react";

import { IoLogoWhatsapp } from "react-icons/io";

import { AOS_ANIMATION } from "../../common/aos_animation";

import styles from "./style.module.css";

const WHATSAPP_NUMBER = "9840717144";
const WHATSAPP_MESSAGE =
  "Hi there! I would like to know more about your services.";

export const WhataApp = () => {
  return (
    <React.Fragment>
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
          WHATSAPP_MESSAGE
        )}`}
        target="_blank"
        rel="noreferrer"
        className={styles.whatsappContainer}
        // data-aos={AOS_ANIMATION.FADE_UP.TYPE}
        // data-aos-duration={AOS_ANIMATION.FADE_UP.DURATION}
      >
        <IoLogoWhatsapp className={styles.icon} />
      </a>
    </React.Fragment>
  );
};
